export enum LocationType {
  District = 'housenumbercm',
  Address = 'addresscm',
  GPS = 'gps',
  Project = 'projectcm',
}

export type LocationTypeName =
  | LocationType.District
  | LocationType.Address
  | LocationType.GPS
  | LocationType.Project

export type Location =
  | LocationDistrict
  | LocationAddress
  | LocationGps
  | LocationProject

export const isLocationObject = (
  locationType: LocationType,
  data: any
): boolean => {
  if (!data) {
    return false
  }
  switch (locationType) {
    case LocationType.District:
      return (
        data.locationCadastralDistrict &&
        data.locationCadastralDistrictId &&
        data.locationCadastralArea &&
        data.locationCadastralAreaId &&
        data.locationHouseNumber &&
        data.locationHouseNumberId
      )
    case LocationType.Address:
      return (
        data.locationAddressDistrict &&
        data.locationAddressDistrictId &&
        data.locationAddress &&
        data.locationAddressId &&
        data.locationAddressStreet &&
        data.locationMunicipality &&
        data.locationMunicipalityId
      )
    case LocationType.GPS:
      return data.locationLat && data.locationLng
    case LocationType.Project:
      return (
        data.locationProjectDistrict &&
        data.locationProjectDistrictId &&
        data.locationProject &&
        data.locationProjectId
      )

    default:
      return false
  }
}

export interface LocationDistrict {
  locationCadastralRegion: string
  locationCadastralRegionId: number
  locationCadastralDistrict: string
  locationCadastralDistrictId: number
  locationCadastralArea: string
  locationCadastralAreaId: number
  locationHouseNumber: string
  locationHouseNumberId: number
}
export const LocationDistrictProperties = [
  'locationCadastralRegion',
  'locationCadastralRegionId',
  'locationCadastralDistrict',
  'locationCadastralDistrictId',
  'locationCadastralArea',
  'locationCadastralAreaId',
  'locationHouseNumber',
  'locationHouseNumberId',
]

export interface LocationAddress {
  locationAddressRegion: string
  locationAddressRegionId: number
  locationAddressDistrict: string
  locationAddressDistrictId: number
  locationAddress: string
  locationAddressId: number
  locationAddressStreet: string
  locationMunicipality: string
  locationMunicipalityId: number
}
export const LocationAddressProperties = [
  'locationAddressRegion',
  'locationAddressRegionId',
  'locationAddressDistrict',
  'locationAddressDistrictId',
  'locationAddress',
  'locationAddressId',
  'locationAddressStreet',
  'locationMunicipality',
  'locationMunicipalityId',
]

export interface LocationGps {
  locationLat: string
  locationLng: string
}
export const LocationGpsProperties = ['locationLat', 'locationLng']

export interface LocationProject {
  locationProjectRegion: string
  locationProjectRegionId: number
  locationProjectDistrict: string
  locationProjectDistrictId: number
  locationProject: string
  locationProjectId: number
  locationProjectBuilding?: string
  locationProjectBuildingId?: number
}
export const LocationProjectProperties = [
  'locationProjectRegion',
  'locationProjectRegionId',
  'locationProjectDistrict',
  'locationProjectDistrictId',
  'locationProject',
  'locationProjectId',
  'locationProjectBuilding',
  'locationProjectBuildingId',
]
